import {mark, types as metrics} from '@servicenow/ui-metrics';

/**
 * Runs effect function (includes async and generator functions)
 *
 * @param fn
 * @param args
 * @returns {Promise}
 */
export default function runEffect(fn, args, {host, interactionId, type}) {
	mark(host, interactionId, metrics.EFFECT_START, {type});
	const generator = fn(...args);

	if (!generator || !generator.next) {
		mark(host, interactionId, metrics.EFFECT_END, {type});
		return Promise.resolve(generator);
	}

	function runner(verb, arg) {
		if (fn.cancelled) {
			mark(host, interactionId, metrics.EFFECT_END, {type});
			return Promise.resolve(generator.return());
		}

		let result;
		try {
			result = generator[verb](arg);
		} catch (err) {
			mark(host, interactionId, metrics.EFFECT_END, {type});
			return Promise.reject(err);
		}

		if (result.done) {
			mark(host, interactionId, metrics.EFFECT_END, {type});
			return Promise.resolve(result.value);
		}

		mark(host, interactionId, metrics.EFFECT_END, {type});
		return Promise.resolve(result.value).then(onResolved, onRejected);
	}

	const onResolved = runner.bind(runner, 'next');
	const onRejected = runner.bind(runner, 'throw');
	return onResolved();
}
